module.exports = __webpack_public_path__ + "media/images/1200/gym-f5fce0d3725d6993e30f4ce7de0c2e39.jpg";